import { Pipe, PipeTransform } from '@angular/core';
import BigNumber from 'bignumber.js';

@Pipe({
    name: 'currency'
})
export class CurrencyPipe implements PipeTransform {

    transform(val: number): string {
        // Format the output to display any way you want here.
        // For instance:
        if (val !== undefined && val !== null) {
            let fmt = {
                prefix: '',
                decimalSeparator: ',',
                groupSeparator: '.',
                groupSize: 3,
                secondaryGroupSize: 3
            };

            let amount = new BigNumber(val).toFormat(2, fmt);
            return amount;
        } else {
            return '';
        }
    }
}